var EntitlementConstants: IEntitlementConstants = {
    ENTITLEMENT_ADD_FORM: 'ENTITLEMENT_ADD_FORM',
    ENTITLEMENT_FORM_INVALID_SAVE: 'ENTITLEMENT_FORM_INVALID_SAVE',

    ENTITLEMENT_RECIEVE_DATA: 'ENTITLEMENT_RECIEVE_DATA',
    ENTITLEMENT_RECIEVE_SETTINGS_DATA: 'ENTITLEMENT_RECIEVE_SETTINGS_DATA',
    ENTITLEMENT_UPDATE_SECURITY_GROUP: 'ENTITLEMENT_UPDATE_SECURITY_GROUP',
    ENTITLEMENT_ADD_USER: 'ENTITLEMENT_ADD_USER',
    ENTITLEMENT_DELETE_USER: 'ENTITLEMENT_DELETE_USER',
    ENTITLEMENT_ADD_EXTERNAL_GROUP: 'ENTITLEMENT_ADD_EXTERNAL_GROUP',
    ENTITLEMENT_DELETE_EXTERNAL_GROUP: 'ENTITLEMENT_DELETE_EXTERNAL_GROUP',
    ENTITLEMENT_UPDATE_PERMISSIONS: 'ENTITLEMENT_UPDATE_PERMISSIONS',

    ENTITLEMENT_BEGIN_ADD: 'ENTITLEMENT_BEGIN_ADD',
    ENTITLEMENT_ADD: 'ENTITLEMENT_ADD',

    ENTITLEMENT_BEGIN_EDIT: 'ENTITLEMENT_BEGIN_EDIT',
    ENTITLEMENT_EDIT: 'ENTITLEMENT_EDIT',
    ENTITLEMENT_FINISH_EDIT: 'ENTITLEMENT_FINISH_EDIT',

    ENTITLEMENT_DELETE: 'ENTITLEMENT_DELETE',
    ENTITLEMENT_DIRECTORY_GROUP_SEARCH: 'ENTITLEMENT_DIRECTORY_GROUP_SEARCH',
    ENTITLEMENT_RECEIVE_SEARCH_HINT: 'ENTITLEMENT_RECEIVE_SEARCH_HINT'
} as const;

export default EntitlementConstants;
